import React, {useContext} from 'react';
import {MapContext} from '../../apiContexts';

const ReplayControls = () => {
    const {replay} = useContext(MapContext);

    if (!replay) return null;

    const {replaying, replaySpeed, playReplay, pauseReplay, setReplaySpeed} = replay;

    return (
        <div className="d-flex align-items-center">
            <button
                type="button"
                className="btn btn-sm btn-outline-primary mr-2"
                onClick={replaying ? pauseReplay : playReplay}
            >
                <span className={`fas fa-${replaying ? 'pause' : 'play'}`} />
            </button>
            <select
                className="form-control form-control-sm"
                style={{width: 'auto'}}
                value={replaySpeed}
                onChange={(event) => setReplaySpeed(Number(event.target.value))}
            >
                <option value={1}>1x</option>
                <option value={5}>5x</option>
                <option value={10}>10x</option>
                <option value={20}>20x</option>
                <option value={30}>30x</option>
            </select>
        </div>
    );
};

export default ReplayControls;
